import dayjs from '@/plugins/dayjs'

/*********************************
 *           DATE AND TIME
 **********************************/
export function toReadableDateTimeFormat(dateTime: string): string {
  return dayjs.utc(dateTime).tz().format('D MMMM YYYY (HH:mm)')
}

/*********************************
*           DATE ONLY
**********************************/
export function toReadableDateFormat(dateTime: string): string {
  return dayjs.utc(dateTime).tz().format('Do MMMM YYYY')
}

// Returns date formated as follows -> Jun 28, 2025
export function toReadableShortDateFormat(dateTime: string): string {
  return dayjs.utc(dateTime).tz().format('MMM D, YYYY')
}

export function toReadableDateFormatWithWeekdayAndYear(dateTime: string): string {
  return dayjs.utc(dateTime).tz().format('dddd Do MMMM YYYY')
}

export function toReadableYearFormat(dateTime: string): string {
  return dayjs.utc(dateTime).tz().format('YYYY')
}

/*********************************
 *           TIME ONLY
 **********************************/
export function toReadable24hTimeFormat(dateTime: string): string {
  return dayjs.utc(dateTime).tz().format('HH:mm')
}

// Returns time formated as follows -> 12:30pm
export function toReadableTimeFormat(dateTime: string): string {
  return dayjs.utc(dateTime).tz().format('h:mma')
}
